import * as React from "react"
import Avatar from "@mui/material/Avatar"
import Button from "@mui/material/Button"
import CssBaseline from "@mui/material/CssBaseline"
import Link from "@mui/material/Link"
import Grid from "@mui/material/Grid"
import Box from "@mui/material/Box"
import LockOutlinedIcon from "@mui/icons-material/LockOutlined"
import Typography from "@mui/material/Typography"
import Container from "@mui/material/Container"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import { Input } from "./Input"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { register, login, reset } from "../../features/auth/authSlice"
import { toast } from "react-toastify"
import axios from "axios"

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://memories-delta-lake.vercel.app/">
        SchoolBus App
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  )
}

const theme = createTheme()

export default function SignUp() {
  const inputFileRef = React.useRef(null)

  const { user, isError, message } = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  React.useEffect(() => {
    if (isError) {
      toast.error(message)
    }
    if (user) navigate("/")
    dispatch(reset())
  }, [user, message, isError, dispatch, navigate])

  const [formData, setFormData] = React.useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
  })

  const [avatarImage, setAvatarImage] = React.useState("")
  const [isSignUp, setIsSignUp] = React.useState(false)
  const [showPassword, setShowPassword] = React.useState(false)
  const handleShowPassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword)
  }
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }
  const handleSubmit = (event) => {
    event.preventDefault()
    if (isSignUp) {
      const dataWithAvatar = { ...formData, avatarImage }
      dispatch(register(dataWithAvatar))
    } else {
      dispatch(login(formData))
    }
  }
  const switchMode = () => {
    setIsSignUp((prevIsSignUp) => !prevIsSignUp)
    setShowPassword(false)
  }

  const handleChangeImageAvatar = async (e) => {
    try {
      const formData = new FormData()
      formData.append("image", e.target.files[0])
      console.log("formData", formData)
      console.log("process.env.REACT_APP_URL", process.env.REACT_APP_URL)
      const { data } = await axios.post(
        `${process.env.REACT_APP_URL}/avatars`,
        formData
      )
      setAvatarImage(data.url)
    } catch (error) {
      console.error(error)
      alert("error avatar")
    }
  }

  const onClickRemoveImage = async (avatarImage) => {
    setAvatarImage("")
    await axios.delete(`${process.env.REACT_APP_URL}/upload-avatar`, {
      data: { file: avatarImage },
    })
  }

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "#d32f2f" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            {isSignUp ? "Sign Up" : "Sign In"}
          </Typography>
          <Box
            component="form"
            noValidate
            onSubmit={handleSubmit}
            sx={{ mt: 3 }}
          >
            <Grid container spacing={2}>
              {isSignUp && (
                <>
                  <Input
                    name="firstName"
                    label="First Name"
                    half
                    handleChange={handleChange}
                  />
                  <Input
                    name="lastName"
                    label="Last Name"
                    half
                    handleChange={handleChange}
                  />
                </>
              )}
              <Input
                name="email"
                label="Email Address"
                type="email"
                handleChange={handleChange}
              />
              <Input
                name="password"
                label="Password"
                type={showPassword ? "text" : "password"}
                handleShowPassword={handleShowPassword}
                handleChange={handleChange}
              />
              {isSignUp && (
                <Input
                  name="confirmPassword"
                  label="Repeat password"
                  type={showPassword ? "text" : "password"}
                  handleShowPassword={handleShowPassword}
                  handleChange={handleChange}
                />
              )}
              {isSignUp && (
                <Grid item xs={12} sm={12}>
                  <Button
                    onClick={() => inputFileRef.current.click()}
                    variant="outlined"
                    size="small"
                  >
                    Download avatar
                  </Button>
                  <input
                    ref={inputFileRef}
                    type="file"
                    onChange={handleChangeImageAvatar}
                    hidden
                  />
                  {avatarImage && (
                    <>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={() =>
                          onClickRemoveImage(
                            avatarImage.match(/avatars\/(.*)/)[1]
                          )
                        }
                        sx={{ marginLeft: 2 }}
                        size="small"
                      >
                        Delete
                      </Button>
                      <Box
                        display="flex"
                        justifyContent="center"
                        sx={{ marginTop: 3 }}
                      >
                        <Avatar
                          alt="Uploaded"
                          src={`${process.env.REACT_APP_URL}${avatarImage}`}
                          sx={{ width: 100, height: 100 }}
                        />
                      </Box>
                    </>
                  )}
                </Grid>
              )}
            </Grid>

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2, borderRadius: 15 }}
              color="error"
            >
              {isSignUp ? "Sign Up" : "Sign In"}
            </Button>

            <Grid container justifyContent="center">
              <Grid item>
                <Button onClick={switchMode}>
                  {isSignUp
                    ? "Already have an account? Sign in"
                    : "Don't have an account? Sign Up"}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Copyright sx={{ mt: 5 }} />
      </Container>
    </ThemeProvider>
  )
}

// working
